export class HideElement {
  constructor(element) {
    this._refs = {
      el: element,
    };

    this.init();
  }

  /**
   * Element = all elements within document
   * children = Only target elements within this element
   */
  get settings() {
    return {
      elements: this._refs.el.getAttribute('data-hide-element'),
      children: this._refs.el.getAttribute('data-hide-children'),
    };
  }

  _addHiddenClass() {
    let allElements;
    if (this.settings.elements) {
      allElements = [...document.querySelectorAll(this.settings.elements)];
    }
    if (this.settings.children) {
      allElements = [...this._refs.el.querySelectorAll(this.settings.elements)];
    }
    if (!allElements) return;
    for (let el of allElements) {
      el.classList.add('is-hidden');
    }
  }

  init() {
    this._addHiddenClass();
  }
}
